export interface EmailModel {
	email: string;
}

export interface LoginModel extends EmailModel {
	password: string;
}

export interface BiometricLoginModel extends LoginModel {
	uniqueId: string; // Should be the device unique id
}

export interface BiometricUniqueIdModel {
	uniqueId: string; // Should be the device unique id
}

export interface ResetPasswordModel extends LoginModel {
	comfirmPassword: string;
	resetPasswordToken: string;
}

export interface RegisterV2Model extends LoginModel {
	firstName: string;
	lastName: string;
	country: string;
	officeId: number;
	directorId: number;
}

export const createResetPasswordModel = (
	resetPasswordModel: ResetPasswordModel = null,
	email: string = null,
	resetPasswordToken: string = null
): ResetPasswordModel => {
	if (resetPasswordModel) return { ...resetPasswordModel, email, resetPasswordToken };
	return {
		email,
		password: '',
		comfirmPassword: '',
		resetPasswordToken
	};
};

export interface SecurityTokenModel extends MobileNumberModel {
	securityToken: string;
}

interface MobileNumberModel {
	mobileNumber: string;
}

export interface OTPModel extends SecurityTokenModel {
	email: string;
	otp: string;
	rememberMe?: boolean;
}

export interface PasswordModel {
	password: string;
}

export interface MobileNumberConfirmationModel extends SecurityTokenModel, EmailModel {
	mobileNumber: string;
}

export interface SmsSecurityCodeVerificationModel extends MobileNumberModel, OTPModel {
	isFromLogin: boolean;
}
